import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { observer } from 'mobx-react';
import useSWR from 'swr';

import { useStores } from '../../../hooks';
import { AmountBadge } from '../../AmountBadge';

import { List, Description } from './components';
import { PAGE_KEY, PER_PAGE } from './const';
import Pagination from '../../Pagination';

import styles from './styles/loyalty_program.module.scss';

export const LoyaltyProgram = observer(() => {
  const [page, setPage] = useState(1);
  const [searchParams, setSearchParams] = useSearchParams();
  const { loyaltyStore, userStore } = useStores();
  const { info, getLoyaltyConfig, infoDocument, getBonusesTransactions } = loyaltyStore;
  const { currentUser, getUser } = userStore;


  const { data: transactionsData } = useSWR(
    {
      page,
      _key: `bonuses-transactions`,
    },
    getBonusesTransactions,
  );

  useSWR(
    {
      _key: 'user-bonuses',
    },
    getUser,
  );

  const handleChangePage = (page) => {
    setSearchParams((searchParams) => {
      searchParams.set(PAGE_KEY, page);
      return searchParams;
    });
    setPage(page);
    getUser();
  };

  useEffect(() => {
    const pageParam = searchParams.get(PAGE_KEY) ?? 1;
    setPage(Number(pageParam));
  }, [searchParams]);

  useEffect(() => {
    (async () => {
      await getUser();
      await getLoyaltyConfig();
    })();
    return () => {
      searchParams.delete('page');
    };
  }, []);

  return (
    <div className={styles.loyalty}>
      {info ? <Description info={info} /> : null}
      {!!infoDocument && infoDocument !== '' && (
        <p className={styles.loyalty__program}>
          Ознакомиться с полными условиями{' '}
          <a
            href={infoDocument}
            download
            className={styles.loyalty__program__link}
            target="_blank"
          >
            программы лояльности
          </a>
        </p>
      )}
      <div className={styles.loyalty__balance}>
        <span>Ваш текущий баланс:</span>
        <AmountBadge
          type="balance"
          amount={currentUser?.bonuses_count}
          currency="₽"
        />
        <div className={styles.loyalty__balance__disabled_bonuses}>
          <AmountBadge
            type="disabled"
            amount={currentUser?.inactive_bonuses_count}
            currency="₽"
          />
          <p className={styles.loyalty__balance__disabled_bonuses__text}>
            Бонусы активируются после завершения текущих сделок
          </p>
        </div>
      </div>
      <div>
        <List items={transactionsData?.results} />
        <Pagination
          paginationProps={{
            onChange: handleChangePage,
            current: page,
            pageSize: PER_PAGE,
            total: transactionsData?.count,
          }}
        />
      </div>
    </div>
  );
});
